import React from 'react'
import moment from 'moment'
import store from '../../store'
import { initializeCustomerLanguage } from '../../actions/customerLanguage'
import { get, del, lget } from '../../utils'
import { Redirect } from 'react-router-dom'
import SocketIOClient from 'socket.io-client';
import { Col, Row, DatePicker, Button, Form, Icon, notification, Switch, Modal, Select, Table } from 'antd'
import CustomTable from '../CustomTable'
import Header from '../../components/Header'
import config from '../../config.json'
import { notiSuccess, notiRemove } from '../../actions/notification';
import { showExpiredModal } from '../../actions/systemmodal';
import { connect } from 'react-redux';
import PaymentOrder from '../../components/Sales/SalesOrder/PaymentOrder';
import TicketModal from '../../components/Chat/TicketChat/TicketModal';
import Statisticstag from './Statisticstag';
import CategoryTicketModal from '../../components/Chat/CategoryChat/CategoryTicketModal';
import CategoryProductModal from '../../components/Product/CategoryProduct/CategoryProductModal';
import CategoryWork from '../../components/Product/CategoryWork';
import TagChatModal from '../../components/Chat/TagChat/TagChatModal';
import CategoryArticleModal from '../../components/Content/CategoryArticle/CategoryArticleModal';
import InviteAdministratorModal from '../../components/Account/Administrator/InviteAdministratorModal';
import ExpiredModal from '../../containers/CustomModal/ExpiredModal';
import './style.scss'

class TableLayout extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            visibleInviteAdministrator: false,
            subComponentName: null,
            editId: null,
            contentList: [],
            ticketUnClose: [],
            ticketUnCloseAdmin: [],
            startDate: null,
            endDate: null,
            selectAdmin: '',
            checked: false,
            category: 'order',
            categoryList: [
                { value: 'order', label: 'สั่งพิมพ์งาน' },
                { value: 'according', label: 'ตามงาน' },
                { value: 'general', label: 'สอบถามทั่วไป' }
            ],
            selectrow: [],
            tempFilter: 'day',
            datastatic: [],
            detailstatic: [],
            ticketNotClose: [],
            visiblemodalNotClosed: false,
            columns: [
                {
                    title: 'Name',
                    dataIndex: 'name',
                    key: 'name',
                    render: text => text,
                },
                {
                    title: 'Number',
                    dataIndex: 'number',
                    key: 'number',
                },
            ],
            createComponentModalPathList: [
                '/ticket_chat',
                '/category_chat',
                '/category_product',
                '/tag_chat',
                '/category_article',
                '/category_work',
            ],
            editComponentModalPathList: [
                '/category_chat',
                '/category_product',
                '/tag_chat',
                '/category_article',
                '/category_work',
            ],
            deleteComponentModalPathList: [
                '/category_chat',
                '/tag_chat',
                '/product',
                '/user_customer',
                '/user_administrator',
                '/category_product',
                '/gallery',
                '/article',
                '/category_article',
                '/package_account',
                '/coupon',
                '/promotion',
                '/category_work',
                '/job_post',
                '/user_report',
                '/user_technician',
                // '/role_administrator'
                '/notification_manual_send',
            ],
            visibleComponentModal: false,

        }
        this.socket = SocketIOClient(`${process.env.REACT_APP_API_PROTOCOL}://${process.env.REACT_APP_API_HOSTNAME}:${process.env.REACT_APP_API_PORT}`);
    }


    getRoleEdit() {
        const { roleDetail, roleKey } = this.props
        if (roleDetail) {
            let index = roleDetail.findIndex(item => item.key === roleKey)
            if (index != -1) {
                return roleDetail[index].edit
            }
            return false
        }
        return false
    }


    convertDDHHmm(secs) {
        let minutes = Math.floor(secs / 60);
        secs = secs % 60;
        let hours = Math.floor(minutes / 60)
        minutes = minutes % 60;
        let day = Math.floor(hours / 24)
        hours = hours % 24
        let daystring = ''
        let hoursstring = ''
        let minstring = ''
        if (day != 0) {
            daystring = `${this.pad(day)} Days `
        }
        if (hours != 0) {
            hoursstring = `${this.pad(hours)} Hours `
        }
        if (minutes != 0) {
            minstring = `${this.pad(minutes)} Min`
        }
        if (secs >= 0 && minutes == 0 && hours == 0 && day == 0) {
            return 'a few minutes ago';
        } else {
            return daystring + hoursstring + minstring;
        }

        // return pad(hours)+":"+pad(minutes)+":"+pad(secs); for old browsers
    }
    pad(num) {
        return ("0" + num).slice(-2);
    }

    getContentList(pathname) {
        const { url, isConnectCodexLearn, codexlearnApiProtocol, codexlearnApiHostname, codexlearnApiPort } = this.props
        // console.log("getContentList this.props", this.props)
        if (isConnectCodexLearn) {
            let serverUrl = `${codexlearnApiProtocol}://${codexlearnApiHostname}:${codexlearnApiPort}` + url
            lget(serverUrl)
                .then(responses => {
                    if (responses.status >= 400) {
                        throw new Error("Bad response from server");
                    }
                    this.setState({ contentList: responses })
                })
                .catch(err => {
                    if (err.message == 'Unauthorized') {
                        this.props.showExpiredModal()
                    }
                    console.log(err.message)
                })
        } else {
            get(url)
                .then(response => {
                    if (response.status >= 400) {
                        throw new Error("Bad response from server");
                    }
                    // console.log("==== response ====",response)
                    response.map(item => {
                        if (item['Day waiting']) {
                            let localtime = moment.utc(item['Day waiting'], 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM-DD HH:mm:ss')
                            let scediff = moment().diff(localtime, 'seconds')
                            item['Day waiting'] = this.convertDDHHmm(scediff)
                        }
                        if (item['Modify Datetime']) {
                            item['Modify Datetime'] = moment.utc(item['Modify Datetime'], 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM-DD HH:mm:ss')
                        }
                        if (item['Create Datetime']) {
                            item['Create Datetime'] = moment.utc(item['Create Datetime'], 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM-DD HH:mm:ss')
                        }
                        return item
                    })

                    let data = []
                    if (pathname == '/tag_chat' || pathname == '/category_chat') {
                        response.map(item => {
                            data.push({
                                name: item.Name,
                                percent: item.Number,
                            })
                        })
                    }
                    else if (pathname == '/article') {
                        response.map(item => {
                            data.push({
                                name: item.NameArticle,
                                percent: item.View,
                            })
                        })
                    }
                    else if (pathname == '/category_product') {
                        response.map(item => {
                            data.push({
                                name: item.Name,
                                percent: item.NumberOfProduct,
                            })
                        })
                    }
                    this.setState({
                        contentList: response,
                        detailstatic: data
                    })

                })
                .catch(err => {
                    if (err.message == 'Unauthorized') {
                        this.props.showExpiredModal()
                    }
                    console.log(err.message)
                })
        }
    }

    openNotification(data) {
        const pathname = this.props.location.pathname
        // console.log("pathname", pathname)
        const key = `open${Date.now()}`;
        const btn = (
            <a target={pathname === '/ticket_chat' ? '_top' : '_blank'} href={'/ticket_chat?ticket=' + data.ticket}>
                <Button
                    type="primary"
                    size="small"
                // onClick={() => this.notificationClicked(data.ticket, key)}
                >View</Button>
            </a>
        );
        notification.open({
            message: '#' + (data.ticket).toString().padStart(9, '0'),
            description: `${data.message.user.name} Say : ${data.message.text}`,
            duration: 4,
            btn,
            key,
            // onClose: close,
        });
    };


    isEmpty(obj) {
        for (var x in obj) { return false; }
        return true;
    }



    ticketNotification(notification) {
        if (!this.isEmpty(notification)) {
            const pathname = this.props.location.pathname
            if (notification.permission == 'client') {
                this.openNotification(notification)
            }
            this.getContentList(pathname)
        }
    }

    getInitializeCustomerLanguage() {
        let url = '/api/crm/administrator/language/raw';
        return get(url)
            .then(responses => {
                if (responses.status >= 400) {
                    throw new Error("Bad response from server");
                }
                store.dispatch(initializeCustomerLanguage(responses))
                return responses
            })
            .catch(err => {
                console.log(err.message)
            })
    }

    componentDidUpdate(prevProps) {
        const { mainCustomerId } = this.props;
        if (mainCustomerId !== prevProps.mainCustomerId) {
            this.getInitializeCustomerLanguage();
        }
      }

    componentDidMount() {
        const pathname = this.props.location.pathname
        const { tempFilter } = this.state
        this.getContentList(pathname)

        this.getstatic(tempFilter)
        // this.getTicketUncloseAdmin()
        if (pathname == '/ticket_chat') {
            this.getTicketNotClose()
            this.setState({ visible: true })
        }
        this.socket.on('administrator-ticket-notification', (response) => this.ticketNotification(response));
        this.props.notiSuccess()
        this.getInitializeCustomerLanguage();
    }

    getTicketNotClose() {
        let url = '/api/crm/administrator/ticket/statusnotclose'
        get(url)
            .then(response => {
                if (response.status >= 400) {
                    throw new Error("Bad response from server");
                }
                this.setState({ ticketNotClose: response })
            })
            .catch(err => {
                if (err.message == 'Unauthorized') {
                    this.props.showExpiredModal()
                }
                console.log(err.message)
            })
    }


    getstatic(tempFilter) {
        const pathname = this.props.location.pathname
        let date = ''
        if (tempFilter == 'day') {
            date = moment().format('YYYY-MM-DD')
        }
        else if (tempFilter == 'week') {
            date = moment().subtract(1, 'weeks').format('YYYY-MM-DD')
        }
        else if (tempFilter == 'month') {
            date = moment().subtract(1, 'months').format('YYYY-MM-DD')
        }
        else {
            date = moment().subtract(1, 'years').format('YYYY-MM-DD')
        }

        let url = ''
        if (pathname == '/tag_chat') {
            url = '/api/administrator/crm/ticket/amountstag?tempFilter=' + date
        }
        else if (pathname == '/article') {
            url = '/api/crm/article/administrator/amountview?tempFilter=' + date
        }
        else if (pathname == '/category_chat') {
            url = '/api/crm/administrator/amountcategory?tempFilter=' + date
        }
        else if (pathname == '/category_product') {
            url = '/api/crm/administrator/amountcategoryproduct?tempFilter=' + date
        }

        if (url != '') {
            get(url)
                .then(response => {
                    if (response.status >= 400) {
                        throw new Error("Bad response from server");
                    }
                    this.setState({ datastatic: response })

                })
                .catch(err => {
                    if (err.message == 'Unauthorized') {
                        this.props.showExpiredModal()
                    }
                    console.log(err.message)
                })
        }
    }

    setdate(filter) {
        this.setState({ tempFilter: filter })
        this.getstatic(filter)

    }

    componentWillUnmount() {
        this.socket.off('administrator-ticket-notification');
    }


    backpage() {
        const { location, isShowTable } = this.props
        const pathname = location.pathname
        this.getContentList(pathname)
        this.setState({ visible: false, editId: null, subComponentName: null })
        // this.getTicketUncloseAdmin()

    }

    refreshPage() {
        const { location } = this.props
        const pathname = location.pathname
        this.getContentList(pathname)

    }

    notificationClicked(editId, key) {
        notification.close(key)
        this.setState({ visible: true, editId: editId, })
    }

    rowClicked(editId) {
        if (this.getRoleEdit()) {
            const { editComponentModalPathList } = this.state
            const pathname = this.props.location.pathname
            if (editComponentModalPathList.includes(pathname)) {
                this.setState({ editId: editId, visibleComponentModal: true })
            } else {
                this.setState({ editId: editId, visible: true })
            }
        }
    }
    subComponentClicked(editId, subComponentName) {
        this.setState({
            visible: true,
            editId: editId,
            subComponentName: subComponentName
        })
    }
    selectAdmin(value) {
        this.setState({ selectAdmin: value })
    }


    onChange(checked) {
        this.setState({ checked: checked })
        if (checked == false) {
            this.setState({ selectAdmin: '' })
        }
    }





    setselectrow(value) {
        this.setState({ selectrow: value })
    }
    OnDelete() {
        const { selectrow } = this.state
        const pathname = this.props.location.pathname
        let data = {
            selectrow: selectrow,
            update_by: this.props.administratorId,
            permission:'administrator'
        }
        let url = ''
        if (pathname == '/category_chat') {
            url = '/api/crm/administrator/category/ticket/'
        }
        if (pathname == '/tag_chat') {
            url = '/api/administrator/crm/ticket/tag/'
        }
        if (pathname == '/product') {
            url = '/api/administrator/crm/product/'
        }
        if (pathname == '/user_customer') {
            url = '/api/crm/administrator/user/customer'
        }
        if (pathname == '/user_administrator') {
            url = '/api/crm/administrator/user/administrator'
        }
        if (pathname == '/category_product') {
            url = '/api/crm/administrator/category/product'
        }
        if (pathname == '/gallery') {
            url = '/api/administrator/gallery'
        }
        if (pathname == '/article') {
            url = '/api/crm/article/administrator'
        }
        if (pathname == '/category_article') {
            url = '/api/crm/administrator/category/article'
        }
        
        if (pathname == '/coupon') {
            url = '/api/crm/administrator/sales/coupon'
        }

        if (pathname == '/promotion') {
            url = '/api/crm/administrator/sales/promotion'
        }

        if (pathname == '/package_account') {
            url = '/api/crm/administrator/package'
        }

        if (pathname == '/category_work') {
            url = '/api/administrator/crm/category/work'
        }

        if (pathname == '/job_post') {
            url = '/api/crm/administrator/user/postwork'
        }
        if (pathname == '/user_report') {
            url = '/api/crm/customer/user/reportuser'
            // url = '/api/administrator/crm/category/work'
        }
        if (pathname == '/user_technician') {
            url = '/api/crm/administrator/user/technician'
        }
        if (pathname == '/notification_manual_send') {
            url = '/api/administrator/crm/notification/manual'
        }
        // if (pathname == '/role_administrator') {
        //     url = '/api/crm/administrator/category/product'
        // }

        if (url != '') {
            del(url, data)
                .then(response => {
                    if (response.status >= 400) {
                        throw new Error("Bad response from server");
                    }
                    this.refreshPage()
                })
                .catch(err => {
                    console.log(err.message)
                })
        }
    }

    onStartDateChange = (value, text) => {
        this.setState({
            startDate: value
        })
    }

    onEndDateChange = (value, text) => {
        this.setState({
            endDate: value
        })
    }


    onCloseComponentModal = () => {
        this.setState({ visibleComponentModal: false, editId: null });
        this.refreshPage()
    };

    renderComponentModal(editId) {
        const pathname = this.props.location.pathname
        const { visibleComponentModal } = this.state
        switch (pathname) {
            case '/ticket_chat':
                return <TicketModal visible={visibleComponentModal} editId={editId} onClose={() => this.onCloseComponentModal()} />
            case '/category_chat':
                return <CategoryTicketModal visible={visibleComponentModal} editId={editId} onClose={() => this.onCloseComponentModal()} />
            case '/category_product':
                return <CategoryProductModal visible={visibleComponentModal} editId={editId} onClose={() => this.onCloseComponentModal()} />
            case '/tag_chat':
                return <TagChatModal visible={visibleComponentModal} editId={editId} onClose={() => this.onCloseComponentModal()} />
            case '/category_article':
                return <CategoryArticleModal visible={visibleComponentModal} editId={editId} onClose={() => this.onCloseComponentModal()} />
            case '/category_work':
                return <CategoryWork visible={visibleComponentModal} editId={editId} onClose={() => this.onCloseComponentModal()} />
            default:
                return null;
        }
    }

    render() {
        const { isAuthenticated, isShowTable, name, subName } = this.props
        const {
            startDate, endDate, visible, ticketUnClose, checked, selectrow, visiblemodalNotClosed, ticketNotClose,
            createComponentModalPathList, editId, deleteComponentModalPathList
        } = this.state
        if (isAuthenticated == false || isAuthenticated == 'false') {
            return <Redirect to='/' />
        }

        const pathname = this.props.location.pathname
        const dateFormat = 'YYYY-MM-DD';
        let Component = this.props.component
        switch (this.state.subComponentName) {
            case 'Payment Order':
                Component = PaymentOrder
                break
        }

        let dataTableList = this.state.contentList.filter(item => {
            if (startDate == null || endDate == null) {
                return true
            }
            if (!item["Create Datetime"]) {
                return true
            } else {
                let momentCreateDate = moment(moment(item['Create Datetime']).format('YYYY-MM-DD'))
                let momentStartDate = moment(moment(startDate).format('YYYY-MM-DD'))
                let momentEndDate = moment(moment(endDate).format('YYYY-MM-DD'))
                if (momentCreateDate >= momentStartDate && momentCreateDate <= momentEndDate) {
                    return true
                }
                return false
            }
        })

        if (pathname == '/ticket' && checked == true) {
            dataTableList = dataTableList.filter(item => item.ผู้รับผิดชอบ == this.state.selectAdmin && item.status != 'ปิด')
        }
        return (
            <div>
                <Header title={name} />
                {visible || !isShowTable ?
                    <Component
                        editId={this.state.editId}
                        backpage={() => this.backpage()}
                    />
                    :
                    <div
                        className={`second-class table-${pathname.slice(1)}-wrapper`}
                    // className={['/category_chat', '/link_chat', '/tag_chat', '/article', '/category_product'].includes(pathname) ? `first-class table-${pathname.slice(1)}-wrapper` : `second-class table-${pathname.slice(1)}-wrapper`} 
                    >
                        <div className="first-section" >
                            <Row className="table-layout" >
                                <Col sm={24} md={12} lg={12} className="left-menu" >
                                    {pathname == '/ticket_chat' ?
                                        <Row className="ticket-chat-menu" gutter={24}>
                                            <Col sm={24} md={12} lg={12} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                <span style={{ width: '40%' }} >Start Date</span> <DatePicker format="YYYY-MM-DD" value={this.state.startDate} onChange={this.onStartDateChange} style={{ width: '60%' }} />
                                            </Col>
                                            <Col sm={24} md={12} lg={12} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                <span style={{ width: '40%' }}>End Date</span> <DatePicker format="YYYY-MM-DD" value={this.state.endDate} onChange={this.onEndDateChange} style={{ width: '60%' }} />
                                            </Col>
                                        </Row>
                                        :
                                        <p style={{ margin: 0, fontSize: 20, marginBottom: 20 }}>{subName}</p>
                                    }

                                </Col>
                                <Col sm={24} md={12} lg={12} className="right-menu" >
                                    {pathname == '/user_administrator' ?
                                        <Button
                                            onClick={() => this.setState({ visibleInviteAdministrator: true })}
                                            style={{
                                                color: '#ffffff',
                                                backgroundColor: this.getRoleEdit() ? '#37ba00' : '#BFBFBF',
                                                border: 'none',
                                                marginLeft: 2,
                                                marginRight: 2,
                                                display: ['/ticket', '/notification_auto_send'].includes(pathname) ? 'none' : 'unset',
                                            }}
                                        >
                                            <Icon type="mail" /> {'Invite'}
                                        </Button>
                                        :
                                        <Button
                                            onClick={() => createComponentModalPathList.includes(pathname) ? this.setState({ editId: null, visibleComponentModal: true }) : this.setState({ editId: null, visible: true })}
                                            style={{
                                                color: '#ffffff',
                                                backgroundColor: this.getRoleEdit() ? '#37ba00' : '#BFBFBF',
                                                border: 'none',
                                                marginLeft: 2,
                                                marginRight: 2,
                                                display: ['/ticket', '/notification_auto_send', '/course', '/category_course','/payment_method', '/user_report'].includes(pathname) ? 'none' : 'unset',
                                            }}
                                            disabled={!this.getRoleEdit()}
                                        >
                                            <Icon type="plus" /> {'Create'}
                                        </Button>
                                    }
                                    <Button type="`primary`"
                                        onClick={() => selectrow.length > 0 ? this.OnDelete() : null}
                                        style={{
                                            color: '#ffffff',
                                            backgroundColor: selectrow.length > 0 ? '#ff0000' : 'rgba(0,0,0,.25)',
                                            border: 'none',
                                            marginLeft: 2,
                                            marginRight: 2,
                                            display: ['/ticket', '/notification_auto_send', '/ticket_chat', '/course', '/category_course','/payment_method'].includes(pathname) ? 'none' : 'unset',
                                        }}
                                        disabled={!selectrow.length}
                                    >
                                        <Icon style={{ fontSize: 18 }} type="delete" />
                                    </Button>
                                    {pathname == '/ticket_chat' ?
                                        <Button type="primary"
                                            onClick={() => this.setState({ visiblemodalNotClosed: true })}
                                            style={{
                                                color: 'rgb(72, 197, 235)',
                                                backgroundColor: '#ffffff',
                                                border: '1px solid rgb(72, 197, 235)',
                                                marginLeft: 2,
                                                marginRight: 2,
                                                display: ['/ticket', '/notification_auto_send'].includes(pathname) ? 'none' : 'unset'
                                            }}
                                        >
                                            {'Tickets not yet closed for sale'}
                                        </Button>
                                        :
                                        ''}
                                </Col>
                            </Row>

                            {pathname == '/ticket' ?
                                <div style={{ marginBottom: '3px' }}>
                                    <Row>
                                        <Switch unCheckedChildren="ซ่อนสรุปจำนวน Ticket ที่ยังไม่ปิดของรายแอดมิน" checkedChildren="แสดงสรุปจำนวน Ticket ที่ยังไม่ปิดของรายแอดมิน" onChange={(value) => this.onChange(value)} />
                                    </Row>
                                    {checked ?
                                        <Row>
                                            {ticketUnClose.map(item => {
                                                if (item.name != 'unknow')
                                                    return (
                                                        <Col span={1} style={{ textAlign: 'center', fontSize: '12px' }}>
                                                            <div style={{ textAlign: 'center' }}>

                                                                <a><span onClick={() => this.selectAdmin(item.name)}>{item.name} :  {item.count}</span></a>

                                                            </div>
                                                        </Col>
                                                    )
                                            })}
                                        </Row>
                                        :
                                        null}
                                </div>
                                :
                                null}
                            <div>
                                <CustomTable
                                    pageName={this.props.subName}
                                    pathName={pathname}
                                    categoryPageName={this.props.name}
                                    content={dataTableList}
                                    checkbox={deleteComponentModalPathList.includes(pathname) ? true : false}
                                    pagination={true}
                                    selectList={this.state.selectrow}
                                    setSelectList={(value) => this.setselectrow(value)}
                                    rowClicked={(editId) => this.rowClicked(editId)}
                                    subComponentClicked={(editId, subComponentName) => this.subComponentClicked(editId, subComponentName)}
                                    refreshPage={() => this.refreshPage()}
                                />
                            </div>
                            {pathname == '/ticket_chat' ?
                                <div>
                                    <Modal
                                        visible={visiblemodalNotClosed}
                                        title="Tickets not yet closed for sale"
                                        onOk={this.CreateTicket}
                                        onCancel={() => this.setState({ visiblemodalNotClosed: false })}
                                        style={{ textAlign: 'center' }}
                                        footer={[
                                            // <Button key="back" onClick={()=> this.props.handleCancel()}>
                                            //     Cancel
                                            // </Button>,
                                            // <Button key="submit" type="primary" onClick={()=> this.CreateTicket()}>
                                            //     Create
                                            // </Button>,
                                        ]}
                                    >
                                        <Table
                                            columns={this.state.columns}
                                            dataSource={ticketNotClose}
                                            pagination={false}
                                        />
                                    </Modal>
                                </div>
                                :
                                ''}
                        </div>
                        {/* <div className="second-section">
                            {['/category_chat', '/link_chat', '/tag_chat', '/article', '/category_product'].includes(pathname) ?
                                <Col sm={24} md={24} lg={24} >
                                    <Statisticstag
                                        setdate={(filter) => this.setdate(filter)}
                                        tempFilter={this.state.tempFilter}
                                        datastatic={this.state.datastatic}
                                        detailstatic={this.state.detailstatic}
                                    />
                                </Col>
                                :
                                ''}
                        </div> */}
                    </div>
                }
                {this.renderComponentModal(editId)}
                <ExpiredModal visible={this.props.showModalExpired} onClose={() => null} />
                <InviteAdministratorModal
                    visible={this.state.visibleInviteAdministrator}
                    onClose={() => this.setState({ visibleInviteAdministrator: false })}
                    refreshPage={() => this.refreshPage()}
                />
            </div>
        )

    }
}

const mapStateToProps = (state) => ({
    notification: state.notification.notification,
    isAuthenticated: state.login.isAuthenticated,
    administratorId: state.login.id,
    mainCustomerId: state.login.mainCustomerId,

    roleDetail: state.role.roleDetail,
    showModalExpired: state.systemmodal.showModalExpired,

    codexlearnApiProtocol: state.login.codexlearn_api_protocol,
    codexlearnApiHostname: state.login.codexlearn_api_hostname,
    codexlearnApiPort: state.login.codexlearn_api_port,

})

const mapDispatchToProps = (dispatch) => ({
    notiSuccess: () => dispatch(notiSuccess()),
    notiRemove: () => dispatch(notiRemove()),
    showExpiredModal: () => dispatch(showExpiredModal())
})

export default connect(mapStateToProps, mapDispatchToProps)(TableLayout);